module.exports = __webpack_public_path__ + "static/safari-pinned-tab-224d14caae3c8e1f2f8d13189a933a1e.svg";